import {
    selectDoc, event, ajax, selectArr
} from "../utils/utils";

import {inputEmail, inputEmpty, serialize, showErrorPDPForm} from "../helpers/service.validator";

import {MiniCart} from "./component.minicart";

const props = {
    open: selectDoc('.gifthy-open'),
    html: selectDoc('html'),
    error: selectDoc('#gifthy-modal .gifthy-form .error'),
    atc: selectDoc('#gifthy-modal .gifthy-form .atc.btn'),
    atcMain: selectDoc('#addToCart')
}

const initOpenModal = (self) => {
    if(props.open) {
        event(props.open, 'click', function (e) {
            e.preventDefault()
            e.stopPropagation()

            let modalOpener = selectDoc('button.modal-open', props.open.parentNode),
                modal = selectDoc(`#${modalOpener.getAttribute('data-m')}`),
                form = selectDoc('form.shopify-product-form');

            if (modal) {
                let form = selectDoc(self.main + ' form.shopify-product-form'),
                    formData = serialize(form);

                if (self.isSimpleProduct) {
                    //validate band size selected...if applies..
                    let sizeTabValidate = selectDoc(self.main + ' .tab.show#size');
                    if (sizeTabValidate) {
                        if (!selectDoc(self.main + ' .tab.show#size .tab-body input.selected')) {
                            let sizeTab = selectDoc(self.main + ' [data-target="size-body"]')
                            if (sizeTab) {
                                showErrorPDPForm(props.open, 'Please select a band size')
                                sizeTab.click()
                            }
                            if (self.productForm) {
                                self.productForm.scrollIntoView();
                            }
                            return;
                        }
                    }

                    let selectedVariant = self.verlasCurrentSize;
                    if (selectedVariant) {
                        formData.id = selectedVariant.value;
                        formData.properties.summary = '';
                        selectArr(self.main + ' .tab.show').map((tab, i) => {
                            let summary = selectDoc(self.main + ' .tab-summary label', tab);
                            if (summary) {
                                formData.properties.summary += (i > 0 ? ' | ' : ' ');
                                switch (tab.id) {
                                    case "size":
                                        formData.properties.summary += 'Size: ';
                                        break;
                                    case "metal":
                                        let metalColor = selectDoc(self.main + ' #metal-color input.selected', tab)
                                        formData.properties.metal_code += metalColor ? metalColor.getAttribute('data-v') : '';
                                        break;
                                }
                                if (summary.getAttribute('data-summary')) {
                                    formData.properties.summary += `${summary.getAttribute('data-summary')}: ${summary.innerText}`
                                } else {
                                    formData.properties.summary += summary.innerText
                                }
                            }
                        })
                        formData.properties.summary = formData.properties.summary.trim();
                    }
                } else {
                    if (self.verlasCurrentSize) {
                        formData.id = self.verlasCurrentSize.getAttribute('data-id');
                        formData.properties.band_size_code = self.verlasCurrentSize.getAttribute('data-sku')
                        formData.properties.band_size = self.verlasCurrentSize.getAttribute('data-title')
                    }

                    //Validate required inputs for complex products
                    if (
                        inputEmpty(formData.properties['diamond_code']) ||
                        inputEmpty(formData.properties['metal_code']) ||
                        (inputEmpty(formData.properties['band_size']) && self.verlasIsRing)
                    ) {
                        let sizeTab = selectDoc(self.main + ' [data-target="size-body"]')
                        if (sizeTab) {
                            showErrorPDPForm(props.open, 'Please select a band size')
                            sizeTab.click()
                        }
                        if (self.productForm) {
                            self.productForm.scrollIntoView();
                        }
                        return;
                    }

                    //Extra properties
                    self.handle && formData.properties ? formData.properties.master = self.handle : '';
                    self.image && formData.properties ? formData.properties.master_img = self.image : '';
                }

                modalOpener.click();
            }
        })
    }
};

const initSubmitForm = () => {
    if(props.atc) {
        event(props.atc, 'click', function (e) {
            e.preventDefault();
            props.error.classList.add('remove');
            let form = selectDoc('#gifthy-modal .gifthy-form form'),
                formData = serialize(form),
                properties = formData.properties;
            if(
                !inputEmail(properties.gifthy_from_email) ||
                !inputEmail(properties.gifthy_to_email) ||
                inputEmpty(properties.gifthy_from_name) ||
                inputEmpty(properties.gifthy_occasion) ||
                inputEmpty(properties.gifthy_to_name) ||
                inputEmpty(properties.gifthy_message)
            ) {
                if(!inputEmail(properties.gifthy_from_email) || !inputEmail(properties.gifthy_to_email)) {
                    props.error.innerHTML = 'Please enter a valid email value.';
                    props.error.classList.add('show')
                } else {
                    props.error.innerHTML = 'Please input all the required data to send tour gift.';
                    props.error.classList.add('show')
                }
            } else {
                let mainForm = selectDoc('form.shopify-product-form [name="form_type"]');
                if(mainForm) {
                    ['occasion', 'message', 'from_email', 'to_email', 'from_name', 'to_name'].map(name => {
                        let gifthyInput = document.createElement('input');
                        gifthyInput.name = `properties[gifthy_${name}]`;
                        gifthyInput.setAttribute('value', properties[`gifthy_${name}`]);
                        gifthyInput.setAttribute('hidden', 'true');
                        mainForm.parentNode.insertBefore(gifthyInput, mainForm.nextSibling);
                    });

                    let close = selectDoc('#gifthy-modal .btn--close.close-modal');
                    close ? close.click() : '';
                    props.atcMain ? props.atcMain.click() : '';
                }
            }
        })
    }
};

const initializer = (PDP) => {
    initOpenModal(PDP);
    initSubmitForm();
}

export const Gifthy = {
    init: (PDP) => initializer(PDP)
}
